import React from "react";
import { ActionIcon } from "../../../components";
import "./styles.scss";

const Index = (props) => (
  <>
    <div className="item">
      <div className={`account-card-summary-wrapper animate__animated  ${props.option}`} onClick={props.onClick}>
        <div className={"acs-left-wrapper d-flex justify-content-between "}>
          <div className={"d-flex  align-items-center"}>
            <ActionIcon size={props.size} type={props.type} icon={props.icon} />
            <div className={"acs-content-details d-flex flex-column"}>
              <div className={"acs-name ml-2"}>{props.menuName}</div>
            </div>
          </div>
          <div className={"amount-wrapper d-flex align-items-center"}>
            <div className={"action-arrow"}>
              <ActionIcon size={props.size} icon={props.actionIcon} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
export default Index;
